/* eslint-disable indent */
/* eslint-disable no-useless-return */
/* eslint-disable max-len */
/* eslint-disable no-undef */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable prefer-arrow-callback */
import 'core-js/features/array/find';
import $ from 'jquery';
import 'slick-carousel/slick/slick.min';
import BLazy from 'blazy';
import App, { fillBasket, ifDropdownBasketEmpty } from './modules/App';
import { AppInit } from './modules/Init';
import { TextInit } from './modules/Text';
import Product from './modules/Product';
import AvailabilityNotification from './modules/AvailabilityNotification';
import Tabs from './modules/Tabs';
import { Modal } from './modules/Modal';
import GetFunction, { Get } from './modules/Get';
// import { deliveries } from './modules/Deliveries';
import { Alert } from './modules/Alert';
import { IconBasket } from './modules/Icons';
import { Validation } from './modules/Validation';
import ProductPhotoSwipe from './modules/ProductPhotoSwipe';
import ScrollTop from './modules/ScrollTop';

const getHotspots = ({ Hotspots }) => {
  if (Hotspots.response) {
    Object.entries(Hotspots.response).forEach(([key, value]) => {
      const hotspot = $(`#${key}`);
      if (!value) {
        hotspot.remove();
        return false;
      }

      hotspot.replaceWith(value);
      hotspot.removeClass('--ajax');
      return false;
    });

    App.vars.scrollTop = new ScrollTop();
    App.vars.hotspotsBlazy = new BLazy({
      offset: 0,
      container: '.hotspot .products',
      success: function bLazySuccesFunc(element) {
        setTimeout(() => {
          $(element).closest('.--skeleton').removeClass('--skeleton');
          $(element).parent().addClass('--loaded');
        }, 200);
      },
    });

    App.fn.splitFirm();
    
    if (typeof tmMultiHornet !== 'undefined') {
      tmMultiHornet('body');
    }
  }
};

App.fn.ProjectorSubmit = function projectorSubmitCallback(target, callback, additionalsData) {
  const form = $(target);
  const data = form.serialize();
  const ajaxData = {
    url: form.attr('action'),
    type: form.attr('method'),
    dataType: 'JSON',
    data: `${data}&getAjax=true${additionalsData}`,
    success: (json) => {
      form.find('.--loading').attr('disabled', false).removeClass('--loading');
      $('.projector__small .--submit').attr('disabled', false).removeClass('--loading');

      if (callback) {
        callback(json);
      }
    },
  };

  $.ajax(ajaxData);
};

App.fn.changeSubVersion = async (newChoosen) => {
  $('#content').addClass('load-content');

  const link = $(newChoosen).find('a').data('href');
  const page = await $.get(link);
  const tm_container = document.querySelector('.tm-hornet-container-slide');

  $('#content').replaceWith($(page).find('#content'));
  $('.breadcrumbs').replaceWith($(page).find('.breadcrumbs'));
  if (tm_container) tm_container.remove();

  App.fn.runAjaxFn();
  App.vars.bLazy.revalidate();
  Get.init();
  App.fn.loadStatsBanner();
  App.runArr(App.fnrun[App.vars.view], App.vars.view);
  App.fn.setGrid();
  App.fn.change_url(link);
};

App.fn.buildBoughtModal = ({ name, price, count, unit, image }) => `
  <section class="product__added-basket">
    <div class="headline --small">${window.Literals.projector.addedBasket}</div>
    <div class="product mb-3">
      <div class="product__name">${name}</div>
      <figure class="product__icon">
        <img src="${image}" />
      </figure>
      <div class="product__prices">
        <div class="product__count">${count} ${unit}</div>
        <strong class="price">${price}</strong>
      </div>
    </div>
    <div class="--actions d-flex justify-content-center">
      <a class="--basket btn --solid --medium" href="/basketedit.php">Przejdź do koszyka</a>
    </div>
  </section>
`;

App.fn.submitProjectorSuccess = ({ basket }) => {
  if (basket.products.length) {
    fillBasket(basket);
    $('.menu__link.--basket .counter').removeClass('--empty');
    let count = 0;
    basket.products.forEach((product) => count += product.count)
    $('.menu__link.--basket .counter').text(count);
  } else {
    ifDropdownBasketEmpty();
    $('.menu__link.--basket .counter').addClass('--empty');
    return;
  }

  $('.menu__link.--basket').removeClass('--empty');

  const product = basket.products.find((element) => element.id === $('#projector_product_hidden').val());
  if (product) {
    Alert.show({ text: window.Literals.projector.addedBasket, mod: '--success', duration: 2500 });

    if (basket.profit_points) {
      const forPointButton = document.querySelector('button.--for-points-submit');
      if (basket.profit_points + parseInt(product.prices.points_price, 10) > parseInt(forPointButton.dataset.client_points, 10)) {
        forPointButton.remove();
      }
    }

    // const html = App.fn.buildBoughtModal({
    //   name: $('.projector__name').text(),
    //   price: $('.projector__price.--price').text(),
    //   count: $('.projector__cart .--quantity').val(),
    //   unit: window.Product.config.unit,
    //   image: $('.projector__photo img').attr('src'),
    // });

    // const addedModal = $('.product__added-basket');
    // if (addedModal.length) {
    //   $('.product__added-basket').parent().html(html);
    //   App.vars.ModalObject.openModal('.--addedBasket');
    // } else {
    //   $('body').append(html);
    //   App.vars.ModalObject.createModal({
    //     selector: '.product__added-basket',
    //     className: '--addedBasket',
    //     isActive: true,
    //   });
    // }
  } else {
    Alert.show({ text: 'Coś poszło nie tak :(', duration: 2500 });
  }
};

App.fn.getProduct = async (product, size, require) => {
  const data = `/ajax/projector.php?product=${product}&size=${size}&get=${require}`;
  const res = await fetch(data);
  if (!res.ok) {
    return null;
  }
  return res.json();
};

App.fn.updateBundle = async () => {
  const product = $('#projector_product_hidden').val();
  let size = $('#projector_size_hidden').val();
  size = size === 'onsize' ? 'uniw' : size;
  let data = $('.bundle .bundled_product, .bundle .product_bundle_size').serialize();
  data = data.replace('onesize', 'uniw');

  const json = await App.fn.getProduct(
    product,
    size,
    `sizeprices,sizeavailability,sizedelivery,bundleprice,bundle&${data}`,
  );
  if (json.sizeprices) {
    window.Product.config.price = json.sizeprices;
  }
  if (json.sizeavailability) {
    window.Product.config.availability = json.sizeavailability;
    window.Product.config.shipping_time = json.sizeavailability.shipping_time;
  }
  window.Product.update();

  if (json.bundle && json.bundle.length) {
    json.bundle.forEach((item) => {
      const parent = $(`.bundle_${item.products_bundled_id}`);

      parent.find('.product-small__icon img').attr('src', item.icon);
      parent.find('.--name').attr('href', item.link);
    });
  }

  $('#content').removeClass('load-content');
};

App.fn.getLowestPrice = async (date, id) => {
  const data = await (await fetch('/graphql/v1/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ query: `query {\n      getLastLowestProductPrices(lastLowestPricesInput: [{ date: "${date}", productId: ${id} }]) {\n        id\n        sizes {\n          id\n          price {\n            gross {\n              value\n              currency\n              formatted\n            }\n          }\n        }\n      }\n    }` }),
  })).json();

  return data;
};

App.fn.hideOmnibusContainer = () => {
  document.querySelector('.projector__prices-omnibus').remove();
};

App.fn.lowestPrice = async () => {
  const lastPriceChangeContainer = document.querySelector('.projector__prices-omnibus');

  if (!lastPriceChangeContainer) return;

  const lastPriceChangeDate = lastPriceChangeContainer ? lastPriceChangeContainer.getAttribute('data-last-change') : '';

  if (!lastPriceChangeDate) {
    App.fn.hideOmnibusContainer();
    return;
  }

  const lowestPrice = await App.fn.getLowestPrice(lastPriceChangeDate, Config.vars.product.id);

  if (!lowestPrice.data || !lowestPrice.data.getLastLowestProductPrices.length) {
    App.fn.hideOmnibusContainer();
    return;
  }

  const [{ sizes }] = lowestPrice.data.getLastLowestProductPrices;

  if (!sizes.length) {
    App.fn.hideOmnibusContainer();
    return;
  }

  document.querySelector('.projector__prices-omnibus--value').textContent = sizes[0].price.gross.formatted;
};

App.fn.calculatePricePerHundred = (price, weight) => (price * 100) / parseInt(weight, 10);
App.fn.calculatePricePerTab = (price, elements) => price / parseInt(elements, 10);

App.fn.pricePer = () => {
  const weightContainer = document.querySelector('.projector__prices-ppg');

  if (!weightContainer) return;

  const context = weightContainer.getAttribute('data-context');

  if (context === 'g' || context === 'ml') {
    const [numberValue, unit] = weightContainer.getAttribute('data-value').split(' ');
    const per100g = App.fn.calculatePricePerHundred(Config.vars.product.price.value, numberValue);
    weightContainer.innerHTML = `${window.Product.formatPrice(per100g)}/100 ${unit}`;
  } else {
    const perUnit = App.fn.calculatePricePerTab(Config.vars.product.price.value, weightContainer.getAttribute('data-value'));
    weightContainer.innerHTML = `${window.Product.formatPrice(perUnit)}/${context}`;
  }
};

App.fn.loadStatsBanner = () => {
  const picture = document.querySelector('.projector__photo[data-slick-index="0"] img');

  if (picture) {
    const statsPicture = document.querySelectorAll('.cm__stats-picture img');
    statsPicture.forEach((pic) => {
      pic.src = picture.src;
    })
  }
}

App.fn.adultOnlyOpen = (isclose) => {
  const adultAlert = document.querySelector('.alert__adult');

  if (!adultAlert) {
    return null;
  }

  if (isclose) {
    adultAlert.setAttribute('hidden', '');
  } else {
    adultAlert.removeAttribute('hidden');
  }
}

App.run(
  () => {
    App.fn.replaceSelects($('.f-select-versions'), '', App.fn.changeSubVersion, () => {
      $('.projector__version li a').each((index, el) => {
        if (el.dataset.img) {
          el.innerHTML = `<img src="${el.dataset.img}" /> ${el.innerHTML}`;
        }
      })
    });
    App.fn.replaceSelects($('.f-select-bundle'), '', async (newChoosen) => {
      const elem = newChoosen.find('a');

      if (!elem.hasClass('selected')) {
        App.fn.dropdownClick(newChoosen, false);
        $('#content').addClass('load-content');

        const product = await App.fn.getProduct(elem.data('product'), 'onesize', 'sizeprices');

        if (!product) {
          return false;
        }
        elem.parents('.bundle__product-outer').find('.bundled_product').val(elem.data('product'));
        elem.parents('.bundle__product-outer').find('.price').text(product.sizeprices.price_formatted);

        App.fn.updateBundle();
        App.runArr(App.fnrun[App.vars.view], App.vars.view);
        App.fn.setGrid()
      }

      return false;
    });

    const hotspotConfig = {
      zonesNames: [],
      zonesTypes: [],
    };

    $.each($('.hotspot.--ajax'), function ajaxHotspotsEach() {
      const self = $(this);

      hotspotConfig.zonesNames.push(self.attr('id'));
      hotspotConfig.zonesTypes.push(self.data('pagetype'));
    });

    if (!(!hotspotConfig.zonesNames.join(',') || !hotspotConfig.zonesTypes.join(','))) {
      Get.Hotspots(
        {
          zonesNames: hotspotConfig.zonesNames.join(','),
          components: hotspotConfig.zonesNames.join(','),
          zonesTypes: hotspotConfig.zonesTypes.join(','),
        },
        getHotspots,
      );
    }

    // Product initialization
    window.Product = new Product({
      config: Config.vars.product,
    });
    App.vars.AvailabilityNotification = new AvailabilityNotification({
      config: Config.vars.product,
    });
    App.vars.ModalObject = new Modal();
    App.vars.projectorTabs = new Tabs({
      selector: '.projector__tabs .--moving-wrapper',
      destination: '.projector__tabs-dest',
    });
    App.vars.ModalObject.createModal({
      selector: '.comment__form.d-none',
      className: '--comments-form',
      activator: '.comments__insert .btn',
    });
    App.vars.ModalObject.createModal({
      selector: '.question__form.d-none',
      className: '--question-form',
      activator: '.questions__insert .btn',
    });

    App.fn.pricePer();

    // GALERIA
    $('.projector__photos:not([data-count="0"]) .projector__photos-inner:not(.slick-slider)')
      .slick({
        lazyLoad: 'ondemand',
        arrows: true,
        prevArrow: '<button class="slick-prev" type="button"></button>',
        nextArrow: '<button class="slick-next" type="button"></button>',
      })
      .on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        $(`.projector__photo-nav[data-index="${nextSlide}"]`).addClass('--active').siblings().removeClass('--active');
      });

    $('.projector__photo-nav:not(.slick-video)').on('click', function changeSlickSlider() {
      const position = $(this).attr('data-index');
      $('.projector__photos-inner.slick-slider').slick('slickGoTo', position);
    });

    $('.projector__photo[data-index]').on('click', function openPhotoSwipe(e) {
      e.preventDefault();
      const index = Number($(this).attr('data-index'));
      const gallery = new ProductPhotoSwipe({
        items: Config.vars.product.enclosures,
        options: {
          index,
        },
      });
    });

    $('.projector__form').on('submit', (e) => {
      e.preventDefault();
    });

    $('.projector__submit, .projector__small .--submit').on('click', function clickSubmit() {
      if (this.dataset['open_alert']) {
        App.fn.adultOnlyOpen();
        return;
      }
      $(this).addClass('--loading').attr('disable', true);
      $('#projector_mode').val('1');

      let additionalData = '';
      if ($('.bundle').length) {
        additionalData = `&${$('.bundle .bundled_product, .bundle .product_bundle_size').serialize()}`;
      }

      App.fn.ProjectorSubmit('.projector__form', App.fn.submitProjectorSuccess, additionalData);
    });

    const acceptAdultAlert = document.querySelector('.alert__adult-yes');
    if (acceptAdultAlert) acceptAdultAlert.addEventListener('click', function onAdultSubmitClick() {
      App.fn.adultOnlyOpen(true);
      $('.projector__submit, .projector__small .--submit').addClass('--loading').attr('disable', true);
      $('#projector_mode').val('1');

      let additionalData = '';
      if ($('.bundle').length) {
        additionalData = `&${$('.bundle .bundled_product, .bundle .product_bundle_size').serialize()}`;
      }

      App.fn.ProjectorSubmit('.projector__form', App.fn.submitProjectorSuccess, additionalData);
    })

    const declineAdultAlert = document.querySelector('.alert__adult-no');
    if (declineAdultAlert) declineAdultAlert.addEventListener('click', () => {
      App.fn.adultOnlyOpen(true);
    })

    $('.--for-points-submit').on('click', function clickSubmit() {
      // $(this).addClass('--loading').attr('disable', true);
      $('#projector_mode').val('1');

      App.fn.ProjectorSubmit('.projector__form', App.fn.submitProjectorSuccess, '&forpoints=1');
    });

    $('.projector__wishlist').on('click', function slickWishlist() {
      const self = $(this);
      self.addClass('--loading').attr('disable', true);
      $('#projector_mode').val('2');

      const additionalData = self.hasClass('--observed') ? '&change=empty' : '';

      App.fn.ProjectorSubmit(
        '.projector__form',
        () => {
          const { addedWishes, removedWishes } = window.Literals.projector;
          Alert.show({ text: self.hasClass('--observed') ? removedWishes : addedWishes, duration: 2500 });
          // $('#clear_product_from_wishes').remove();
          const GetWhishes = new GetFunction();
          GetWhishes.Wishlist(({ Wishlist }) => {
            $('.menu__link.--list .counter').removeClass('--empty');
            $('.menu__link.--list .counter').text(Wishlist.response ? Wishlist.response.product.length : '');
          });
          GetWhishes.init();
          self.toggleClass('--observed');
          self.removeClass('--loading').attr('disable', false);
        },
        additionalData,
      );
    });

    $(document).on('click', '.bundle__product-version li a', function clickDropdown(e) {
      e.preventDefault();
    });

    $('.--nutrit style').remove();

    $('.projector__tab, .projector__base-opinions .--scroll').on('click', function clickTabLabel() {
      const self = $(this);
      const dest = $(self.data('scroll'));

      if (!dest.find('.--label').hasClass('--expanded')) {
        dest.find('.--label').addClass('--expanded');
        dest.find('.--label').next().slideDown();
      }
    });

    $('.addons .--show-products, .bundles .--show-products').on('click', function addonsExpandButtonClick() {
      $(this).parents('.--expandable').toggleClass('--expanded');
      App.vars.bLazy.revalidate();
    });

    $('.projector__tabs-dest .--label').on('click', function switchDescriptionVisibility() {
      const self = $(this);
      self.next().slideToggle();
      self.toggleClass('--expanded');
    });

    $('.opinion_star').on('click', function clickOnStarOpinion() {
      const self = $(this);
      const points = self.siblings('strong');
      const input = self.siblings('input');
      self.find('i').addClass('--active');
      self.prevAll('a').find('i').addClass('--active');
      self.nextAll('a').find('i').removeClass('--active');
      points.text(self.attr('title'));
      input.val(self.attr('rel'));
      return false;
    });

    $('.question .--title').on('click', function clickQuesitonTitle() {
      const self = $(this);
      self.toggleClass('--expanded');
      if (self.next().hasClass('--anserw')) {
        self.next().slideToggle();
      }
    });

    $('.--scroll').on('click', function scrollButtonClick() {
      const self = $(this);
      const scrollDestination = $(self.data('scroll'));

      if (scrollDestination.length) {
        $('body, html').animate({ scrollTop: scrollDestination.offset().top - 170 }, 500);
      }
    });

    // Until IdoSell will fix bug with delivery cost

    // $('.--check-shipping').on('click', function checkShippingClick() {
    //   const product = document.querySelector('#projector_product_hidden').value;
    //   const size = document.querySelector('#projector_size_hidden').value;
    //   const quantity = document.querySelector('input.--quantity').value;

    //   $.ajax({
    //     url: `/ajax/get-deliveries.php?mode=productAndBasket&products[${product}][${
    //       size === 'onesize' ? 'uniw' : size
    //     }][${quantity}]=1`,
    //     type: 'POST',
    //     data: 'getAjax=true',
    //     dataType: 'JSON',
    //     success: (res) => {
    //       const shippingModal = $('.shipping__modal');
    //       if (shippingModal.length) {
    //         $('.shipping__modal').parent().html(deliveries(res));
    //         App.vars.ModalObject.openModal('.--shipping');
    //       } else {
    //         $('body').append(deliveries(res));
    //         App.vars.ModalObject.createModal({
    //           selector: '.shipping__modal',
    //           className: '--shipping',
    //           isActive: true,
    //         });
    //       }
    //     },
    //   });
    // });

    $(document).on('submit', '.comment__form-wrapper', function submitOpinion(event) {
      event.preventDefault();
      const isError = Validation.validateForm(event, [...this.querySelectorAll('.--validate-input')]);

      if (isError) {
        return;
      }

      $('.comment__form-button .btn').addClass('--loading');
      const self = $(this);
      const ajaxConfig = {
        url: self.attr('action'),
        type: self.attr('method'),
        dataType: 'json',
        data: self.serialize(),
        success: (json) => {
          if (!Array.isArray(json.errors) && json.errors.faultString) {
            Alert.show({ duration: 2500, text: json.errors.faultString });
            return;
          }
          if (App.vars.ModalObject.modals['.--comments-form']) {
            App.vars.ModalObject.closeModal('.--comments-form');
          }
          Alert.show({ duration: 2500, text: Literals.projector.opinionAdded });

          self.find('.f-control').each(function eachInputs() {
            const input = this;
            Validation.clearStatus(input);
            input.value = '';
            input.classList.remove('focused');
          });

          $('.comment__form-button .btn').removeClass('--loading');
          $('.comment__form-stars a').removeClass('active');
          $('.comment__form-stars .--active').removeClass('--active');
          $('input[name="rating"]').val(5);
        },
      };

      $.ajax(ajaxConfig);
    });

    if ($('.addons').length) {
      Get.Product(
        $('.addons').data('products'),
        (json) => {
          if (json.error) {
            return;
          }

          const productList = json.Product.response.product;
          if (!productList.length) {
            return;
          }

          const availableProducts = productList.filter((item) => item.sizes.size.attributes.amount != 0);
          if (!availableProducts.length) {
            $('.addons').hide();
          }
          const splitedProducts = availableProducts.splice(0, 3);

          const namesArray = splitedProducts.map((item) => item.name);
          const htmlArray = splitedProducts.map(
            (item) => `
          <div class="product-small addons__product product__actions col-sm-4">
            <figure class="product-small__icon">
              <a class="product-small__icon-link" href="${item.attributes.link}" title="${item.name}">
                <img src="${item.icon}">
              </a>
            </figure>
            <div class="product-small__middle">
              <a href="${item.attributes.link}" class="--name"><strong>${item.name}</strong></a>
              <div class="product-small__price">
                <span class="price">${item.price.attributes.price_formatted}</span>
              </div>
            </div>
            <button class="btn --secondary --solid --medium ${
              json.Basket && json.Basket.response.basket.products.filter((elem) => elem.id === item.attributes.id).length && '--active'
            }" type="button" data-sellby="${item.sizes.attributes.unit_sellby}" data-id="${
              item.attributes.id
            }" data-size="uniw">
              ${IconBasket}
            </button>
          </div>`,
          );

          $('.addons__list').html(htmlArray.join(''));
          $('.addons__list-mobile').removeClass('--skeleton').html(namesArray.join(', '));
        },
        true,
      );
    }

    App.fn.splitFirmProjector();
  },
  'all',
  '.page__projector',
  true,
);

App.run(() => {
  $(document).on('click', '.product-small .btn', function clickAddBasket() {
    const self = $(this);
    self.addClass('--loading');
    const data = `product=${self.data('id')}&size=uniw&number=1&getAjax=true${
      self.hasClass('--active') ? '&change=empty' : ''
    }`;

    $.ajax({
      type: 'POST',
      url: '/basketchange.php',
      data,
      dataType: 'JSON',
      success: ({ basket }) => {
        Alert.show({
          text: self.hasClass('--active')
            ? Literals.projector.removedProductBasket
            : Literals.projector.addedProductBasket,
          mod: '--info',
          duration: 2500,
        });
        if (basket.products.length) {
          fillBasket(basket);
          $('.menu__link.--basket .counter').removeClass('--empty');
          let count = 0;
          basket.products.forEach((product) => count += product.count)
          $('.menu__link.--basket .counter').text(count);
        } else {
          ifDropdownBasketEmpty();
          $('.menu__link.--basket .counter').addClass('--empty');
          return;
        }
        self.removeClass('--loading');
        self.toggleClass('--active');
      },
    });
  });
}, 'all');

/**
 *  --Product video--
 */
App.run(
  () => {
    const yt = (url) => {
      const iframeDiv = document.createElement('div');
      iframeDiv.classList.add('video__iframe');
      iframeDiv.innerHTML = `
        <iframe
          width="760" 
          height="423" 
          src="${url}" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen="">
        </iframe>
    `;
      return iframeDiv;
    };

    window.addEventListener('load', function () {
      const modal = document.querySelector('.video-modal');
      const closeButton = document.querySelector('.video-close-button');
      const trigger = document.querySelector('.video__link');

      function toggleModal() {
        // e.preventDefault()
        const iframeDiv = document.querySelector('.video__iframe');
        const modalContent = document.getElementById('modal-content');
        if (!iframeDiv) {
          const url = document.querySelector('.video__link').getAttribute('href');
          const iframe = yt(url);

          modalContent.appendChild(iframe);
          modal.classList.toggle('show-modal');
        } else {
          modal.classList.toggle('show-modal');
          const node = document.querySelector('.video__iframe');
          if (node.parentNode) {
            node.parentNode.removeChild(node);
          }
        }
      }

      function windowOnClick(event) {
        if (event.target === modal) {
          toggleModal();
        }
      }

      trigger.addEventListener('click', toggleModal);
      closeButton.addEventListener('click', toggleModal);
      window.addEventListener('click', windowOnClick);
    });
  },
  'all',
  '.video__link',
);

App.run(
  () => {
    App.fn.loadStatsBanner();
  },
  'all',
  '.cm__stats-picture'
)

App.run(
  () => {
    $('.projector__cart ').prepend($('.projector__quantity'))
  },
  1,
  '.page__projector .projector__quantity',
)

App.run(
  () => {
    $('.projector__version.--version_quantity .--list').append($('.projector__quantity'))
  },
  [2, 3, 4],
  '.page__projector .projector__quantity',
)

AppInit();
TextInit();
